/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimCenterWithBookables
 */
export interface ClaimCenterWithBookables {
    /**
     * Optional email to send ics calendar events to for reservations. If null no events will be sent for that claim
     * center.
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    calendarEmail?: string | null;
    /**
     * Optional notes to display to visitors of this claim center in communications, such as parking details.
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    visitorNotes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimCenterWithBookables
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimCenterWithBookables
     */
    latitude: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    buildingName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    address2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    address1: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimCenterWithBookables
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimCenterWithBookables
     */
    bookableIds: Array<string>;
}

/**
 * Check if a given object implements the ClaimCenterWithBookables interface.
 */
export function instanceOfClaimCenterWithBookables(value: object): value is ClaimCenterWithBookables {
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('address1' in value) || value['address1'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('bookableIds' in value) || value['bookableIds'] === undefined) return false;
    return true;
}

export function ClaimCenterWithBookablesFromJSON(json: any): ClaimCenterWithBookables {
    return ClaimCenterWithBookablesFromJSONTyped(json, false);
}

export function ClaimCenterWithBookablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterWithBookables {
    if (json == null) {
        return json;
    }
    return {
        
        'calendarEmail': json['calendarEmail'] == null ? undefined : json['calendarEmail'],
        'visitorNotes': json['visitorNotes'] == null ? undefined : json['visitorNotes'],
        'longitude': json['longitude'],
        'latitude': json['latitude'],
        'postalCode': json['postalCode'],
        'region': json['region'],
        'city': json['city'],
        'buildingName': json['buildingName'] == null ? undefined : json['buildingName'],
        'address2': json['address2'] == null ? undefined : json['address2'],
        'address1': json['address1'],
        'phone': json['phone'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
        'bookableIds': json['bookableIds'],
    };
}

export function ClaimCenterWithBookablesToJSON(value?: ClaimCenterWithBookables | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'calendarEmail': value['calendarEmail'],
        'visitorNotes': value['visitorNotes'],
        'longitude': value['longitude'],
        'latitude': value['latitude'],
        'postalCode': value['postalCode'],
        'region': value['region'],
        'city': value['city'],
        'buildingName': value['buildingName'],
        'address2': value['address2'],
        'address1': value['address1'],
        'phone': value['phone'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
        'bookableIds': value['bookableIds'],
    };
}

